const keys = {
    USER: '/user',
    SIGN_IN: '/find-user',
    VALIDATE_VERIFICATION_CODE: '/validate-verification-code',
    LOGIN: '/login',
    REGISTER: '/register',
    FORGET_PASSWORD: '/forgot-password',
    SEND_VERIFICATION_CODE: '/send-verification-code'
};

export default keys;

// find-user -> body -> username
// validate-verification-code -> body-> username , verification_code
// login -> body -> username , *varification_code or *password
// register -> body -> first_name , last_name , username , password , **verification_code(from validate-verification-code)
